module.exports = __webpack_public_path__ + "img/02.3fa2ffff.png";